import { Accept, FileRejection } from 'react-dropzone';

import { ObjectValues } from 'helpers/types';

export interface IFileDropzoneProps<T> {
  name: string;
  disabled?: boolean;
  maxSize?: number;
  placeholder?: string;
  acceptedFormats: Accept;
  className?: string;
  wrapperClassName?: string;
  files?: T[];
  errorText?: string;
  multiple?: boolean;
  isLoading?: boolean;
  width?: number;
  height?: number;
  onFileUpload: (files: File[], fileRejections: FileRejection[]) => Promise<void>;
  onDelete?: (index: number) => void;
}

export const DROPZONE_STATUS = {
  default: 'default',
  disabled: 'disabled',
  error: 'error',
  loading: 'loading',
  dragActive: 'dragActive',
} as const;

export type IDropzoneStatus = ObjectValues<typeof DROPZONE_STATUS>;

export const DROPZONE = 'dropzone';
